import React, { createRef, useContext, useState, useEffect } from 'react';
import "./NewSalesPaymentsForm.css";
import { Button, FileInput, Grid, MultiSelect, NumberInput, Pill, Select, Switch, TextInput } from "@mantine/core";
import MantineSwitchButton from "../../../../components/MantineSwitchButton/MantineSwitchButton";
import PhoneInputField from "../../../../components/PhoneInputField/PhoneInputField";
import MantineSelect from "../../../../components/MantineSelect/MantineSelect";
import AppContext from "../../../../contexts/AppContext";
import axios from "axios";
import showNotification from "../../../../utils/showNotification";
import { DateInput } from '@mantine/dates';
import moment from 'moment';
import { INSCRIPTION_ORIGIN_DATA } from '../SalesPaymentsForm/SalesPaymentsForm';
import { IconExternalLink, IconPhoto } from '@tabler/icons-react';
import { renderFile } from '../../../../utils/renderFile';
import { isBase64 } from '../../../../utils/isBase64';
import { openBase64InNewTab } from '../../../../utils/openBase64InNewTab';
import { openUrl } from '../../../../utils/openUrl';

const PAYMENT_METHODS = [
   { value: "paypal", label: "PayPal" },
   { value: "transfer", label: "Transferencia Bancaria" },
   {value: "link", label: "Link de pago"}
];
const CURRENCIES = [
   { value: "USD", label: "USD" },
   { value: "ARS", label: "ARS" },
   // { value: "UYU", label: "UYU (peso uruguayo)" },
   // { value: "BOB", label: "BOB (peso boliviano)" }, 
];

const mapDivision = (dvs) => {
   if (!dvs) return ""
   if (dvs.toUpperCase() === 'LARGE') return "Grandes"
   if (dvs.toUpperCase() === 'SMALL') return "Pequeños"
   return "Exóticos"
}

function NewSalesPaymentsForm(props) {
   const { form, loading, isSubscription = false } = props;
   const { academicUnitsWithDivision, subscriptions, staffUsers, bankAccountsOptions } = useContext(AppContext);

   const ref = createRef();
   const [loadingDiscount, setLoadingDiscount] = useState(false)

   useEffect(() => {
      if (form.values.alreadyUser) {
         form.setFieldValue("email", form.values.email)
         form.setFieldValue("emailConfirmation", form.values.email)
      }
   }, [form.values.alreadyUser])



   const handleApplyDiscount = async (_discountCode, id) => {
      try {
         setLoadingDiscount(true);

         const discountResponse = await axios.post(
            `${process.env.REACT_APP_BACKEND_SERVER}info/checkDiscountCode`,
            { code: _discountCode, id }
         );

         const discountInfoData = discountResponse.data.data;

         if (discountInfoData && discountInfoData.active) {
            form.setFieldValue("discount", discountInfoData._id);
            form.setFieldValue("discountPercentage", discountInfoData.percentage);
         } else {
            showNotification({
               color: "yellow",
               status: "warning",
               title: "El descuento no es válido.",
               message: 'Detalle: Parece que el descuento no existe o ya fue aplicado.',
               autoClose: 12000
            });
         }
      } catch (error) {
         console.error("Error fetching discount data:", error);
         showNotification({
            color: "red",
            status: "error",
            title: "Ha ocurrido un problema al aplicar el descuento.",
            message: `Detalle: ${error.message}`,
            autoClose: 12000
         });
      } finally {
         setLoadingDiscount(false);
      }
   };

   const getUserForm = (_isAlreadyUser) => {
      if (_isAlreadyUser) {
         return (
            <>
               <Grid.Col span={6}>
                  <TextInput
                     label="Email"
                     {...form.getInputProps("email")}
                     onBlur={(event) =>
                        form.setFieldValue("email", event.currentTarget.value)
                     }
                     withAsterisk
                  />
               </Grid.Col>
               <Grid.Col span={6}>
                  <TextInput
                     label="Confirmación de email"
                     {...form.getInputProps("emailConfirmation")}
                     onBlur={(event) =>
                        form.setFieldValue("emailConfirmation", event.currentTarget.value)
                     }
                     withAsterisk
                  />
               </Grid.Col>
            </>
         );
      } else {
         return (
            <>
               <Grid.Col span={6}>
                  <TextInput label="Nombre" {...form.getInputProps("name")} w={"100%"}
                     withAsterisk />
               </Grid.Col>
               <Grid.Col span={6}>
                  <TextInput label="Apellido" {...form.getInputProps("lastname")} w={"100%"}
                     withAsterisk />
               </Grid.Col>
               <Grid.Col span={6}>
                  <TextInput
                     label="Email"
                     {...form.getInputProps("email")}
                     onBlur={(event) =>
                        form.setFieldValue("email", event.currentTarget.value)
                     }
                     withAsterisk
                  />
               </Grid.Col>
               <Grid.Col span={6}>
                  <TextInput
                     label="Confirmación de email"
                     {...form.getInputProps("emailConfirmation")}
                     onBlur={(event) =>
                        form.setFieldValue("emailConfirmation", event.currentTarget.value)
                     }
                     withAsterisk
                  />
               </Grid.Col>
               <Grid.Col span={6}>
                  <PhoneInputField
                     ref={ref}
                     name="phone"
                     fieldError={form.errors.phone}
                     {...form.getInputProps("phone")}
                     onChange={(value) => {
                        form.setFieldValue("phone", value)
                     }}
                     withAsterisk
                  />
               </Grid.Col>
               <Grid.Col span={6}>
                  <TextInput
                     label="Número de identificación (DNI)"
                     withAsterisk
                     {...form.getInputProps("dni")}
                     w={"100%"}
                  />
               </Grid.Col>
               {/*<Grid.Col span={12}>*/}
               {/*    <TextInput label="DNI" {...form.getInputProps("DNI")} w={"100%"}/>*/}
               {/*</Grid.Col>*/}
            </>
         )
      }
   }

   return (
      <Grid style={{ width: "100%" }} justify="center" align="center">
         <Grid.Col span={12} justify="center" align="center">
            <MantineSwitchButton
               styles={{
                  root: {
                     width: "100%",
                     display: "flex",
                     justifyContent: "center",
                  }
               }}
               checked={form.values.alreadyUser}
               onChange={() =>
                  form.setFieldValue("alreadyUser", !form.values.alreadyUser)
               }
               label="El usuario ya existe en FORVET"
            />
         </Grid.Col>
         {getUserForm(form.values.alreadyUser)}

         <Grid.Col span={6} >
            {!isSubscription ?
               <MultiSelect
                  onChange={(value) => {
                     form.setFieldValue("academicUnitId", value)
                     const currentItem = academicUnitsWithDivision.find(item => item.value === value[0])
                     if (currentItem) {
                        form.setFieldValue("division", currentItem.division)
                     }
                  }}
                  name="academicUnitId"
                  value={Array.isArray(form.values.academicUnitId) ? form.values.academicUnitId : [form.values.academicUnitId] || []}
                  label="Unidad académica"
                  description="Selecciona la capacitación a la que corresponde la inscripción"
                  data={
                     academicUnitsWithDivision
                        .filter(item => {
                           const currentYear = moment().year().toString();
                           const nextYear = moment().add(1, 'years').year().toString();
                           const lastYear = moment().subtract(1, 'years').year().toString();

                           return item.label.includes(currentYear)
                              || item.label.includes(nextYear)
                              || item.label.includes(lastYear);
                        })
                        .map(item => ({ label: item.label, value: item.value }))
                  }
                  withAsterisk
                  searchable
               />
               : <MantineSelect
                  form={form}
                  name="subscriptionId"
                  label="Plan de suscripción"
                  description="Selecciona la capacitación a la que corresponde la suscripción"
                  options={subscriptions}
                  withAsterisk
               />
            }
         </Grid.Col>
         {!isSubscription && <Grid.Col span={6} style={{ alignSelf: "end" }}>
            <TextInput

               disabled
               label="División"
               value={mapDivision(form.values.division) || ""}
            />
         </Grid.Col>}
         {isSubscription &&
            <>
               <Grid.Col span={6} style={{ alignSelf: "end" }}>
                  <MantineSelect
                     form={form}
                     name="is_active"
                     label="Estado"
                     allowDeselect={false}
                     options={[
                        {
                           value: 'true',
                           label: "Activa"
                        },
                        {
                           value: 'false',
                           label: "No activa"
                        }
                     ]}
                     withAsterisk
                     required
                  />
               </Grid.Col>
               <Grid.Col span={6}>
                  <DateInput
                     form={form}
                     name='endDate'
                     onChange={(value) => form.setFieldValue('endDate', moment(value).toISOString())}
                     label="Válida hasta"
                     description='Fecha de vencimiento de la suscripción hsata la siguiente cuota.'
                     withAsterisk
                     required
                  />

               </Grid.Col>
            </>
         }
         <Grid.Col span={6}>
            <TextInput
               label="Código de descuento"
               withAsterisk
               placeholder="COVETSALT-AEEC-D7SN"
               {...form.getInputProps("discount")}
               w={"100%"}
            />
         </Grid.Col>
         <Grid.Col span={2}>
            <Button
               type="button"
               className="eventCalendarForm__form__button"
               disabled={!form.values.academicUnitId}
               loading={loadingDiscount}
               onClick={() => handleApplyDiscount(form.values.discount, form.values?.academicUnitId)}
               w={"100%"}
            >
               Validar
            </Button>
         </Grid.Col>
         <Grid.Col span={4}>
            <TextInput
               disabled
               label="Porcentaje descuento"
               {...form.getInputProps("discountPercentage")}
               w={"100%"}
            />
         </Grid.Col>
         <Grid.Col span={6}>
            <Select
               {...form.getInputProps("sellerId")}
               withAsterisk
               label="Vendedor a cargo"
               required
               searchable
               data={staffUsers?.filter(item => item?.roles?.includes('ventas'))}
            />
         </Grid.Col>

         <Grid.Col span={6}>
            <Select
               label="Cuenta de recepción"
               withAsterisk
               required
               data={bankAccountsOptions}
               {...form.getInputProps("bankTransferAccount")}
               searchable
            />
         </Grid.Col>
         <Grid.Col span={12}>
            <Select
               label="Origen de registro"
               data={INSCRIPTION_ORIGIN_DATA}
               {...form.getInputProps("inscriptionOrigin")}
            />
         </Grid.Col>
         <Grid.Col span={6}>
            <MantineSelect
               form={form}
               // name="paymentMethod"
               label="Plataforma de pago"
               options={PAYMENT_METHODS}
               {...form.getInputProps("paymentMethod")}

               withAsterisk
            />
         </Grid.Col>
         <Grid.Col span={6}>
            <MantineSelect
               form={form}
               name="currency"
               label="Moneda"
               options={CURRENCIES}
               withAsterisk
            />
         </Grid.Col>

         <Grid.Col span={6}>
            <NumberInput
               label="Importe ya abonado"
               {...form.getInputProps("amountDeposited.amount")}
            />
         </Grid.Col>
         <Grid.Col span={6}>
            <Select
               {...form.getInputProps("amountDeposited.currency")}
               label="Moneda"
               data={CURRENCIES}
            />
         </Grid.Col>



         <Grid.Col span={6}>
            <FileInput
               {...form.getInputProps("receipt")}
               label="Cargar nuevo comprobante de pago"
               description="El nuevo comprobante de pago reemplazará al anterior."
               withAsterisk
               w={"100%"}
               placeholder="Cargar imagen"
               leftSection={<IconPhoto size={30} />}
               disabled={loading}
               onChange={(file) => {
                  renderFile(file).then((_fileBase64) => {
                     form.setFieldValue("receipt", _fileBase64);
                  });
               }}
               accept={["image/*", "application/pdf"]}
            />
         </Grid.Col>
         {!form.values.receipt && <Grid.Col span={6} />}
         {form.values.receipt && (
            <Grid.Col span={6}>
               <div className="SalesPaymentForm-iamgeLink-div">
                  <h6 className="SalesPaymentForm-image-header">
                     Link del comprobante
                  </h6>
                  <div className="SalesPaymentForm-pill-container">
                     <Pill>{form.values.receipt}</Pill>
                     <IconExternalLink
                        className="materialsTable__icon"
                        onClick={() => {
                           if (
                              !form.values.receipt ||
                              form.values.receipt === "Comprobante pendiente"
                           ) {
                              showNotification({
                                 color: "yellow",
                                 status: "warning",
                                 title: "El comprobante no existe",
                                 message: `Detalle: No se ha cargado un comprobante de pago.`,
                                 autoClose: 12000,
                              });
                           } else if (isBase64(form.values.receipt)) {
                              openBase64InNewTab(form.values.receipt);
                           } else {
                              openUrl(form.values.receipt);
                           }
                        }}
                     />
                  </div>
               </div>
            </Grid.Col>
         )}


         <Grid.Col span={12}>
            <div className="salesPaymentForm-typeSelect">
               <Select
                  data={[{ value: "true", label: "SI" }, { value: "false", label: "NO" }]}
                  label="Está agregado en WhatsApp"
                  defaultValue={'false'}
                  allowDeselect={false}
                  {...form.getInputProps('is_already_in_wp')}
               />
            </div>
         </Grid.Col>

         <Grid.Col span={12}>
            <Button
               type="submit"
               className="eventCalendarForm__form__button"
               loading={loading}
            >
               Guardar inscripción
            </Button>
         </Grid.Col>
         <Grid.Col span={12}>

         </Grid.Col>
      </Grid>
   );
}

export default NewSalesPaymentsForm;